<template>
  <sn-shadow
    class="d-flex align-center zero-state-card"
  >
    <v-container
      px-3
      fluid
    >
      <v-row
        no-gutters
        align="center"
        data-cy="zero-state-card"
      >
        <sn-illustration
          :illustration="illustration"
          width="58"
          height="auto"
        />
        <v-col class="ml-3">
          <div class="sn-h4 sn-text-primary-03">
            {{ title }}
          </div>
          <div class="sn-body-2 sn-text-primary-01">
            {{ subtitle }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </sn-shadow>
</template>

<script>
import snShadow from '~/components/snui/v2/snShadow/snShadow'
import snIllustration from '~/components/snui/v2/snIllustration/snIllustration'

export default {
  name: 'SnZeroStateCard',

  components: {
    snShadow,
    snIllustration
  },

  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    illustration: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.zero-state-card {
  min-height: 96px;
}
</style>
